import React, { useState, useEffect, useRef } from 'react';
import constants from '../../../constants/constants';
import "../../../assets/css/Project.css"
import { useStoreActions, useStoreState } from 'easy-peasy';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import back from "../../../images/back.svg";
import timer from './../../../images/timer.png';
import delaytimer from './../../../images/delaytimer.png';
import { Divider } from 'primereact/divider';
import { differenceInBusinessDays } from 'date-fns';
import { Button } from "primereact/button";
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import axiosInstance from '../../../constants/axiosInstance';
import ProjectTaskAdmin from '../projects/ProjectTaskAdmin';

const TaskDashboard = () => {
    const toast = useRef(null);
    const [records, setRecords] = useState();
    const [projectName, setProjectName] = useState();
    const [taskName, setTaskName] = useState();
    const [milestone, setMilestone] = useState();
    const [endDate, setEndDate] = useState();
    const [userList, setUserList] = useState();
    const [completionDate, setCompletionDate] = useState();
    const [taskStatus, setTaskStatus] = useState();
    const [empName, setEmpName] = useState();
    const [customerName, setCustomerName] = useState();
    const [clientList, setClientList] = useState();
    const [userId, setUserId] = useState();
    const [completionStatus, setCompletionStatus] = useState();
    const [isLoading, setIsLoading] = useState(false);
    // const [viewScreen, setViewScreen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const viewScreen = useStoreState((actions) => actions.projectModel.viewScreen);
    const setViewScreen = useStoreActions((actions) => actions.projectModel.setViewScreen);
    const projectViewDatas = useStoreState((actions) => actions.projectModel.projectViewDatas);
    const setProjectViewDatas = useStoreActions((actions) => actions.projectModel.setProjectViewDatas);
    const setUserDashboardFilterProjects = useStoreActions((actions) => actions.projectModel.setUserDashboardFilterProjects);
    const userDashboardFilterProjects = useStoreState((actions) => actions.projectModel.userDashboardFilterProjects);
    const setFilterProjects = useStoreActions((actions) => actions.projectModel.setFilterProjects);
    const setLoginDetails = useStoreActions((actions) => actions.projectModel.setLoginDetails);
    const loginDetails = useStoreState((actions) => actions.projectModel.loginDetails);
    const subTaskProjectName = useStoreState((actions) => actions.projectModel.subTaskProjectName);
    const setSubTaskProjectName = useStoreActions((actions) => actions.projectModel.setSubTaskProjectName);
    const subTaskRedirect = useStoreState((actions) => actions.projectModel.subTaskRedirect);
    const setSubTaskRedirect = useStoreActions((actions) => actions.projectModel.setSubTaskRedirect)
    const fromDashboard = useStoreState((actions) => actions.projectModel.fromDashboard);
    const setFromDashboard = useStoreActions((actions) => actions.projectModel.setFromDashboard);

    useEffect(() => {
        setIsLoading(true);
        setUserId(loginDetails)
        getProjects(loginDetails);
        getUserList();
        getClientList();
        setFilterProjects(null);
        setViewScreen(null);
        setSubTaskProjectName(null); 
        setSubTaskRedirect(null);
        setFromDashboard(null);
    }, []);
   
    const getUserList = () => {
        setIsLoading(true);
        axiosInstance
            .get(constants.URL.USERS + "?page=1&limit=1000&sort_by=-created_at")
            .then((resp) => {
                setUserList(resp?.data?.data);
            })
            .catch((e) => console.error(e))
            .finally(() => {
                setIsLoading(false);
            });
    }

    const getClientList = () => {
        setIsLoading(true);
        axiosInstance
            .get(constants.APQP_UPL.CLIENT_REGISTRY + "?page=1&limit=1000&sort_by=-created_at")
            .then((resp) => {
                setClientList(resp?.data?.data);
            })
            .catch((e) => console.error(e))
            .finally(() => {
                setIsLoading(false);
            });
    }

    const getProjects = (id) => {
        axiosInstance.get(constants.APQP_UPL.PROJECT_ASSIGNED_BY_USER_ID + id)
            .then((resp) => {
                const data = resp?.data?.data?.flatMap(record => {
                    return record.taskHeader_id.flatMap(header => {
                        return header.subTasks.map(subTask => {
                            return {
                                ...record,
                                headerTitle: header.headerTitle,
                                subTaskName: subTask.subTaskName,
                                subTaskStatus: subTask.subTaskStatus,
                                subTaskRemarks: subTask.subTaskRemarks,
                                taskHeaderId: header._id,
                                subTaskId: subTask._id,
                                subTaskEndDate: subTask.endDate,
                                subTaskStartDate: subTask.startDate,
                                uploadAttachment: subTask.uploadAttachment,
                                completedDate: subTask.completedDate,
                                completionStatus: subTask.completionStatus,
                                delayDayCount: subTask.delayDayCount,
                                taskCriticalityStatus: header.taskCriticalityStatus,
                            };
                        });
                    });
                })
                setRecords(data);
            }).catch((e) => {
                console.error(e);
            }).finally(() => {
                setIsLoading(false);
                setEmpName(id); 
            })
    }
    
    const handleChildData = (data) => {
        getProjects(userId);
    };

    useEffect(() => {
        if (userDashboardFilterProjects) {
            const status = userDashboardFilterProjects?.cardValue
            if (status === "Delayed") {
                setCompletionStatus(status);
            } else {
                setTaskStatus(status);
            }
        }
    }, [userDashboardFilterProjects]);

    useEffect(() => {
        if (projectName || milestone || taskName || endDate || completionDate || taskStatus || completionStatus) {

        }
    }, [projectName, milestone, taskName, endDate, completionDate, taskStatus, completionStatus]);

    const handleView = (item) => {
        if ((item?.projectStatus !== "Hold") && (loginDetails === userId)) {
            setProjectViewDatas(item);
            setViewScreen(true);
            setSelectedRow(item);
        }
    }

    const formatDate = (value) => {
        var date = value ? new Date(value) : null;
        return date?.toLocaleDateString('en-US', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
        });
    }

    const statusBodyTemplate = (status) => {
        let statusStyle;
        switch (status) {
            case 'Completed':
                statusStyle = { color: '#659000', background: '#ECFCC0', display: "inline" };
                break;
            case 'In-Progress':
                statusStyle = { color: '#9E00C6', background: '#F9E1FF', display: "inline" };
                break;
            case "Open":
                statusStyle = { color: '#493BD7', background: '#E2DFFF', display: "inline" };
                break;
            default:
                statusStyle = { color: 'black', background: '' };
        }

        return <div style={statusStyle} className='task-status'>{status ? status : "Open"}</div>;
    };

    const HoldBodyTemplate = (status) => {
        let statusStyle;
        switch (status) {
            case 'Hold':
                statusStyle = { color: '#DF5D40', background: '#FFDBD4', border: "1px solid #FFDBD4", display: "inline" };
                break;
        }

        return <span style={statusStyle} className='task-status'>{status === "Hold" ? status : ""}</span>;
    }

    const headerTemplate = (data) => {
        return (
            <React.Fragment>
                <span className="group-project-name" style={{ marginRight: '10px' }}>{data.projectName}</span>
                <span className="">{HoldBodyTemplate((data?.projectStatus))}</span>
            </React.Fragment>
        );
    };
    const [expandedRows, setExpandedRows] = useState([]);

    const calculateWorkingDaysDelay = (rowData) => {
        const endDate = new Date(rowData.subTaskEndDate)
        const completionDate = new Date(rowData.completedDate);

        if (isNaN(endDate) || isNaN(completionDate)) {
            return 'Invalid Date';
        }

        const delay = differenceInBusinessDays(completionDate, endDate);
        return delay > 0 ? `${delay} days` : 'No Delay';
    };

    const dateRowFilterTemplate = (options) => {
        return (
            <Calendar
                value={options.value ? new Date(options.value) : null}
                onChange={(e) => options.filterApplyCallback(e.value)}
                dateFormat="dd-mm-yy"
                placeholder="Select a date"
            />
        );
    };

    const handleClear = () => {
        setCustomerName();
        setEndDate();
        setTaskStatus();
        setUserId();
        setViewScreen(false);
        getProjects(null);
    }

    const exportExcel = async () => {
        setIsLoading(true);
            try {
                const response = await axiosInstance.get(constants.APQP_UPL.DOWNLOAD_BY_ASSIGNED_TO + "/" + userId, {
                    // headers: getHeaders(),
                    responseType: "blob",
                });                  
              const url = URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "Task Dashboard.xlsx");
        
              document.body.appendChild(link);
              link.click();
              URL.revokeObjectURL(url);
            } catch (error) {
              console.error("Error downloading file:", error);
            } finally {
                setIsLoading(false);
            };
    }

    return (
        <div>
            <Toast ref={toast} />
            {!viewScreen ?
                <div>
                    <div className='flex justify-content-between align-items-center'>                    
                    <div>
                        <h3 className="mb-0 user-dashboard-title">Tasks Dashboard</h3>
                    </div>
                    <div>
                         <Button onClick={exportExcel} label='Download' className='btn-black' />
                    </div>
                    </div>

                    <Divider />
                    <div className="card" style={{ backgroundColor: '#F8F8F8' }}>
                        <form className="error_msg">
                            <div className='flex col-12 flex-container'>
                                <div className="w-full">
                                    <Dropdown value={empName} options={userList} optionLabel='first_name' optionValue='_id' filter className="w-full" placeholder={isLoading ? "Loading..." : "Employee"} disabled={isLoading} onChange={(e) => {getProjects(e.target.value); setUserId(e.target.value);}} />
                                </div>
                                <div className="w-full">
                                    <span className="w-full">
                                        <Dropdown options={clientList} optionLabel='customerName' optionValue='_id' className='dropdown-input' value={customerName} placeholder={isLoading ? "Loading..." : "Customer"} disabled={isLoading} onChange={(e) => setCustomerName(e.target.value)} style={{ width: '100%' }} />
                                    </span>
                                </div>
                                <div className="w-full">
                                    <span className="w-full">
                                        <Calendar className='dropdown-input' value={endDate} placeholder="End Date" onChange={(e) => setEndDate(e.target.value)} style={{ width: '100%' }} dateFormat="yy" view="year" showIcon />
                                    </span>
                                </div>
                                <div className="w-full">
                                    <Dropdown value={taskStatus} options={["Open", "In-Progress", "Completed"]} className="w-full" placeholder="Subtask Status" onChange={(e) => setTaskStatus(e.target.value)} />
                                </div>
                                <div className='project_search'>
                                    <Button className="btn-black mt-1" label="Clear" onClick={handleClear} />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="grid mt-3">
                        <div className="col-12">
                            <div className="table-wrapper user-proj">
                                <DataTable loading={isLoading} emptyMessage={!customerName && records && records?.length === 0 ? "Please select an Employee name to view the data." : "No records available!"} value={records?.filter((item) => {
                                    const cliendId = customerName ? item?.client_id === customerName : true;
                                    const endDateMatch = endDate ? item?.projectEndDate?.includes(endDate.getFullYear()) : true;
                                    const status = taskStatus ? item?.subTaskStatus?.includes(taskStatus) : true;

                                    return status && endDateMatch && cliendId
                                })
                            } selectionMode="single"  selection={selectedRow} removableSort onSelectionChange={(e) => handleView(e.value)}
                                    sortOrder={1} sortMode="single" groupRowsBy="projectName" sortField="projectName" rowGroupMode="subheader"
                                    expandableRowGroups expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)}
                                    scrollable rowGroupHeaderTemplate={headerTemplate} rowClassName={rowData => rowData.taskCriticalityStatus === "Hold" ? 'hold-projects-disabled-row' : ''} >
                                    <Column field="subTaskName" header="Task Name" sortable showFilterMenu={false} style={{ minWidth: '180px' }} filter filterPlaceholder="Search by name" className='user-project-header' bodyClassName="user-project-bodyColumn"></Column>
                                    <Column field="headerTitle" header="Milestone" sortable showFilterMenu={false} filter filterPlaceholder="Search by name" className='user-project-header' bodyClassName="user-project-bodyColumn" style={{ minWidth: '200px' }}></Column>
                                    <Column field="subTaskEndDate" header="End Date" sortable filterField="date" dataType="date" showFilterMenu={false} filter filterPlaceholder="Search by name" body={(rowData)=> formatDate(rowData?.subTaskEndDate)} className='user-project-header' bodyClassName="user-project-bodyColumn" style={{ minWidth: '140px' }}></Column>
                                    <Column field="completedDate" header="Completion Date" sortable filterElement={dateRowFilterTemplate} showFilterMenu={false} filter filterPlaceholder="Search by name" body={(rowData)=> formatDate(rowData?.completedDate)} className='user-project-header' bodyClassName="user-project-bodyColumn" style={{ minWidth: '140px' }}></Column>
                                    <Column field="subTaskStatus" header="Status" sortable showFilterMenu={false} filter filterPlaceholder="Search by name" body={(rowData) => statusBodyTemplate(rowData?.subTaskStatus)} className='user-project-header' bodyClassName="user-project-bodyColumn" style={{ minWidth: '150px' }}></Column>
                                    <Column field="completionStatus" header="Completion Status" sortable showFilterMenu={false} filter filterPlaceholder="Search by name" body={(rowData) => (<span className={rowData?.completionStatus === "Delayed" ? 'delayed' : rowData?.completionStatus === "OnTime" ? 'ontime' : ''}> {rowData?.completionStatus === "Delayed" ? <img src={delaytimer} style={{ paddingRight: '3px', width: '19px', height: '17px' }} /> : rowData?.completionStatus === "OnTime" ? <img src={timer} style={{ paddingRight: '3px', width: '19px', height: '17px' }} /> : null} {rowData?.completionStatus} </span>)} className='user-project-header'></Column>
                                    <Column  field="delayDayCount" header="Number of delayed days" sortable className='user-project-header' bodyClassName="user-project-bodyColumn" style={{ minWidth: '125px' }} />
                                    <Column field="subTaskRemarks" header="Comments" sortable  showFilterMenu={false}  className='user-project-header' bodyClassName="user-project-bodyColumn" style={{ minWidth: '200px' }}></Column>
                                </DataTable>
                            </div>
                        </div>
                    </div>
                </div>
                : <div>
                <div className="title1 cursor-pointer mt-2" onClick={() => { setViewScreen(false); setSelectedRow(null); getProjects(userId); }}>
                    <img src={back} className="back-logo mr-2" />
                    <span className="PS-title pt-2">Task Dashboard / {projectViewDatas?.subTaskName}</span>
                </div>
                <hr className="hr-line"></hr>
                <ProjectTaskAdmin sendDataToParent={handleChildData} />
            </div>}
        </div>
        
    )
}

export default TaskDashboard